import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';

interface HasFeatureSignature {
  Args: {
    Positional: [string];
  };
  Return: boolean;
}

export default class HasFeatureHelper extends Helper<HasFeatureSignature> {
  @service declare access: Services['access'];

  compute([
    featureFlag,
  ]: HasFeatureSignature['Args']['Positional']): HasFeatureSignature['Return'] {
    return this.access.hasFeature(featureFlag);
  }
}
